<template>
  <div>
    <div class="flex flex-col mb-6">
      <div class="flex flex-col md:flex-row my-4 justify-between items-center">
        <div class="sub-heading my-2">Stats</div>
        <div class="space-x-2">
          <button class="button button-primary rounded" :class="{ 'button-dark': channel === 'instagram' }" @click="changeChannel('instagram')">
            Instagram
          </button>
          <button class="button button-primary rounded" :class="{ 'button-dark': channel === 'tiktok' }" @click="changeChannel('tiktok')">
            TikTok
          </button>
          <button class="button button-primary rounded" :class="{ 'button-dark': channel === 'youtube' }" @click="changeChannel('youtube')">
            Youtube
          </button>
        </div>
      </div>
      <div>
        *Disclaimer: The numbers displayed below are updated just 7 days after your social media post. You will find the
        most recent and precise metrics directly in your account.
      </div>
    </div>

    <div v-if="isLoading" class="w-full flex flex-col items-center justify-center p-12">
      <LoadingComponent></LoadingComponent>
    </div>
    <div v-else>
      <div v-if="message !== ''" v-text="message"></div>
      <div v-if="hasInsights">
        <div class="flex flex-wrap sm:flex-no-wrap flex-row justify-between flex-grow space-x-4">
          <template v-for="(insight, index) in insights">
            <dashboard-counter :key="index" :counter="insight"></dashboard-counter>
          </template>
        </div>
      </div>
      <div v-if="!hasPosts" class="text-center my-8 w-full">
        {{ missingPosts }}
      </div>
      <div v-if="hasPosts" class="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-4 flex">
        <div v-for="post in posts" :key="post.id" class="flex-1">
          <dashboard-post :post="post" :creator="creator"></dashboard-post>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import isNull from 'lodash/isNull';
import isUndefined from 'lodash/isUndefined';
import isEmpty from 'lodash/isEmpty';

export default {
  name: 'InsightsDashboard',
  props: {
    delay: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    isLoading: true,
    channel: 'instagram',
    channels: {
      instagram: 'Instagram',
      tiktok: 'TikTok',
      youtube: 'YouTube',
    },
    message: '',
    posts: [],
    creator: {},
    insights: {},
  }),
  computed: {
    hasInsights() {
      return !isNull(this.insights) || !isUndefined(this.insights);
    },
    hasPosts() {
      return !isNull(this.posts) || !isUndefined(this.posts) || !isEmpty(this.posts) || this.posts.length !== 0;
    },
    missingPosts() {
      return `🤷‍♀️ No ${this.channels[this.channel]} posts yet. Go create something new`;
    },
  },
  watch: {
    async channel() {
      await this.getPosts();
    },
  },
  async mounted() {
    setTimeout(async () => {
      await this.getPosts();
    }, this.delay);
  },
  methods: {
    async getPosts() {
      this.isLoading = true;
      const { data } = await window.axios.get(`/dashboard/get-stats?channel=${this.channel}`);

      if (data && data.success) {
        this.insights = data.insights;
        this.posts = data.posts;
        this.creator = data.creator;
      }

      this.message = data.message;
      this.isLoading = false;
    },
    changeChannel(channel) {
      this.channel = channel;
    },
  },
};
</script>
